/* tslint:disable */
/* eslint-disable */
/**
 * bi-api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Pagination } from './Pagination';
import {
    PaginationFromJSON,
    PaginationFromJSONTyped,
    PaginationToJSON,
    PaginationToJSONTyped,
} from './Pagination';
import type { Invoice } from './Invoice';
import {
    InvoiceFromJSON,
    InvoiceFromJSONTyped,
    InvoiceToJSON,
    InvoiceToJSONTyped,
} from './Invoice';

/**
 * 
 * @export
 * @interface ProfileInvoicesResponse
 */
export interface ProfileInvoicesResponse {
    /**
     * 
     * @type {Array<Invoice>}
     * @memberof ProfileInvoicesResponse
     */
    data: Array<Invoice>;
    /**
     * 
     * @type {Pagination}
     * @memberof ProfileInvoicesResponse
     */
    pagination: Pagination;
}

/**
 * Check if a given object implements the ProfileInvoicesResponse interface.
 */
export function instanceOfProfileInvoicesResponse(value: object): value is ProfileInvoicesResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    if (!('pagination' in value) || value['pagination'] === undefined) return false;
    return true;
}

export function ProfileInvoicesResponseFromJSON(json: any): ProfileInvoicesResponse {
    return ProfileInvoicesResponseFromJSONTyped(json, false);
}

export function ProfileInvoicesResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProfileInvoicesResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': ((json['data'] as Array<any>).map(InvoiceFromJSON)),
        'pagination': PaginationFromJSON(json['pagination']),
    };
}

export function ProfileInvoicesResponseToJSON(json: any): ProfileInvoicesResponse {
    return ProfileInvoicesResponseToJSONTyped(json, false);
}

export function ProfileInvoicesResponseToJSONTyped(value?: ProfileInvoicesResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': ((value['data'] as Array<any>).map(InvoiceToJSON)),
        'pagination': PaginationToJSON(value['pagination']),
    };
}

